import { startOfToday } from "date-fns";
const SELECT_DATE = "SELECT_DATE";
const SELECT_SITE = "SELECT_SITE";
const SELECT_ROLES = "SELECT_ROLES";
const TOGGLE_APP_SWITCHER = "TOGGLE_APP_SWITCHER";
const TOGGLE_FILTERS = "TOGGLE_FILTERS";
const ADD_MESSAGE = "ADD_MESSAGE";
const DISMISS_MESSAGE = "DISMISS_MESSAGE";
const SEARCH_BOOKINGS_QUERY_INPUT = "SEARCH_BOOKINGS_QUERY_INPUT";
const SEARCH_ALL_DATES_CHANGE = "SEARCH_ALL_DATES_CHANGE";

export default function reducer(
  state = {
    selectedDate: startOfToday(),
    selectedSite: null,
    searchBookingsQuery: "",
    searchAllDates: false,
    roles: [],
    showAppSwitcher: false,
    showFilters: false,
    messages: [],
    nextMessageId: 0
  },
  action = {}
) {
  switch (action.type) {
    case SELECT_DATE:
      return {
        ...state,
        selectedDate: action.date
      };
    case SELECT_SITE:
      return {
        ...state,
        selectedSite: parseInt(action.site) || null
      };
    case SEARCH_BOOKINGS_QUERY_INPUT:
      return {
        ...state,
        searchBookingsQuery: action.query
      };
    case SEARCH_ALL_DATES_CHANGE:
      return {
        ...state,
        searchAllDates: action.value
      };
    case SELECT_ROLES:
      return {
        ...state,
        roles: action.roles
      };
    case TOGGLE_APP_SWITCHER:
      return {
        ...state,
        showAppSwitcher: !state.showAppSwitcher
      };
    case TOGGLE_FILTERS:
      return {
        ...state,
        showFilters: !state.showFilters
      };
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [
          ...state.messages,
          {
            type: action.messageType,
            message: action.message,
            id: state.nextMessageId
          }
        ],
        nextMessageId: state.nextMessageId + 1
      };
    case DISMISS_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter(m => m.id !== action.index)
      };

    default:
      return state;
  }
}

export function selectDate(date) {
  return { type: SELECT_DATE, date };
}

export function selectSite(site) {
  return { type: SELECT_SITE, site };
}

export function searchBookingsQueryInput(query) {
  return { type: SEARCH_BOOKINGS_QUERY_INPUT, query };
}

export function searchAllDatesChange(value) {
  return { type: SEARCH_ALL_DATES_CHANGE, value };
}

export function setRoles(roles) {
  return { type: SELECT_ROLES, roles };
}

export function toggleAppSwitcher() {
  return { type: TOGGLE_APP_SWITCHER };
}

export function toggleFilters() {
  return { type: TOGGLE_FILTERS };
}

export function addMessage(messageType, message) {
  return { type: ADD_MESSAGE, messageType, message };
}

export function dismissMessage(index) {
  return { type: DISMISS_MESSAGE, index };
}
